export default "__VITE_ASSET__c18ac694__"